module.exports = __webpack_public_path__ + "static/img/RWAG.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/RWAG.png
// module id = krXf
// module chunks = 0